
export const SET_EVENT_DETAIL = 'SET_EVENT_DETAIL';
export const SET_EVENT_CEREMONY = 'SET_EVENT_CEREMONY';
export const SET_JUDGING_SESSION = 'SET_JUDGING_SESSION';
export const SET_MATCHES_SESSION = 'SET_MATCHES_SESSION';
export const SET_CLEAR_ALL_SESSION = 'SET_CLEAR_ALL_SESSION';
export const SET_CLEAR_JUDGING_SESSION = 'SET_CLEAR_JUDGING_SESSION';
export const SET_CLEAR_MATCHES_SESSION = 'SET_CLEAR_MATCHES_SESSION';
export const SET_IMPORT_SCHEDULE = 'SET_IMPORT_SCHEDULE';
export const RESET_IMPORT_SCHEDULE_MODAL = 'RESET_IMPORT_SCHEDULE_MODAL';
export const SET_EVENT_SCHEDULE_INVITED = 'SET_EVENT_SCHEDULE_INVITED';
export const SCHEDULE_BEGIN = 'SCHEDULE_BEGIN';
export const SCHEDULE_BEGIN_ERROR = 'SCHEDULE_BEGIN_ERROR';
export const SCHEDULE_BEGIN_SUCCESS = 'SCHEDULE_BEGIN_SUCCESS';
export const SET_COUNT_NEW_JUDGING_PANEL = 'SET_COUNT_NEW_JUDGING_PANEL';
export const SET_COUNT_NEW_MATCHES_PANEL = 'SET_COUNT_NEW_MATCHES_PANEL';